export { default as CreateProjectInTeamAuthFormFooter } from './CreateProjectInTeamAuthFormFooter';
